var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-activity-table',{attrs:{"title":_vm.$t('global.models.bpc-activity.heading'),"subtitle":_vm.$t('global.models.bpc-activity.subheading'),"select-config-name":['part1', 'part2']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }